import { Component, OnInit } from '@angular/core';
import { MediaService } from 'src/app/core/services/media.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'hch-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss'],
})
export class TermsConditionsComponent implements OnInit {
  constructor(public bsModalRef: BsModalRef, public mediaService: MediaService) {}

  ngOnInit(): void {}
}
